const createJsxFactory = ({ settings: { createElement, forwardRef } }, { rule: ruleFn })=>{
    const createJsx = (tag, propertiesOrRule, attributes)=>{
        if (!createElement) {
            throw new Error("No createElement function passed.");
        }
        let ruleSelector;
        let ruleClass;
        if (Array.isArray(propertiesOrRule)) {
            [ruleSelector, ruleClass] = propertiesOrRule;
        } else {
            const [createdRuleSelector, createdRuleClass] = ruleFn(propertiesOrRule);
            ruleSelector = createdRuleSelector;
            ruleClass = createdRuleClass;
        }
        const hasForwardRef = typeof forwardRef === "function";
        const jsxFn = ({ children, className, ...props }, ref)=>{
            const useClassName = [
                ruleClass,
                className
            ].filter(Boolean);
            const { modifyProps, ...restAttributes } = attributes || {};
            const useProps = {
                className: useClassName.join(" "),
                ...hasForwardRef ? {
                    ref
                } : {},
                ...restAttributes,
                ...props
            };
            modifyProps?.(useProps);
            return createElement(tag, useProps, children);
        };
        const finalJsxFn = hasForwardRef ? forwardRef(jsxFn) : jsxFn;
        finalJsxFn.ruleSelector = ruleSelector;
        finalJsxFn.ruleClass = ruleClass;
        return [
            finalJsxFn,
            ruleSelector,
            ruleClass
        ];
    };
    const createJsxControl = (tag, [styled, rule, , keys], attributes)=>{
        const { modifyProps, ...restAttributes } = attributes || {};
        const [jsxFn] = createJsx(tag, [
            undefined,
            rule
        ], {
            ...restAttributes,
            modifyProps: (props)=>{
                props.style = {
                    ...styled(props),
                    ...props.style || {}
                };
                // Remove customizable control properties from the rendered DOM
                const controlValues = {};
                for (const key of keys){
                    controlValues[key] = props[key];
                    delete props[key];
                }
                modifyProps?.(props, controlValues);
            }
        });
        return jsxFn;
    };
    return {
        jsx: createJsx,
        jsxControl: createJsxControl
    };
};
export { createJsxFactory };
